export default "__VITE_ASSET__Csx79wxp__"